import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ContactInfoProps {
	icon: IconDefinition;
	label: string;
	value: string;
}

export const PlayerContactInfo = ({ icon, label, value }: ContactInfoProps) => {
	return (
		<div className="max-w-[300px] flex-1 pb-4 pr-16 sm:pb-0">
			<p className="flex items-center text-sm font-medium text-gray-700">
				<FontAwesomeIcon icon={icon} className="mr-4 size-5 text-gray-700" />
				{label}
			</p>
			<p className="px-3 py-2 pt-4 text-sm font-medium text-gray-900">{value}</p>
		</div>
	);
};
